//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      leftDrawerOpen: true,
      list_menu : [],
      nama : '',
      email : '',
    };
  },

  methods: {
    logout: function() {
      localStorage.removeItem("token");
      localStorage.removeItem("profile");
      localStorage.removeItem("menu");
      localStorage.removeItem("listmenu");
      this.$router.push("/login");
    },


    checkLength (data){
         var panjang = data.length
        //  return panjang

         var falsx = false 

        data.forEach(element => {
            if (element.view == true) {
                falsx = true                
            }
        });


        return falsx

    }

  },

  computed:{
    checkLogin() {
        if (this.$route.name === 'login' || this.$route.name === 'register') {
            return true;
        } else {
            return false;
        }
    },    
  },

  

  mounted () {
      console.log(this.$store.state.lcProfile)
        //   this.list_menu = localStorage.menu
      this.list_menu = JSON.parse(localStorage.menu);


      var get_profile = JSON.parse(localStorage.profile);
    this.$store.state.lcProfile = get_profile.profile;

    this.nama = this.$store.state.lcProfile.nama;
    this.email = this.$store.state.lcProfile.email;

    //   console.log(localStorage.menu)
    //   console.log(this.$store.state.lcProfile.level)
  },



};
